var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 39C0 17.4609 17.4609 0 39 0C60.5391 0 78 17.4609 78 39V78H39C17.4609 78 0 60.5391 0 39Z",
    fill: "#F44748"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0118 37.644H57.6487C57.6487 28.3154 50.6058 21.2798 41.2644 21.2798V24.9167C48.651 24.9167 54.0118 30.2684 54.0118 37.644Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2827 32.1903C45.1069 32.1903 46.7381 33.8215 46.7381 37.6457H50.375C50.375 31.7812 47.1472 28.5534 41.2827 28.5534V32.1903ZM47.5054 42.0882C47.156 41.7706 46.6969 41.6012 46.2249 41.6158C45.7529 41.6304 45.3051 41.8278 44.976 42.1664L40.6244 46.6416C39.577 46.4416 37.4712 45.7851 35.3036 43.623C33.136 41.4535 32.4796 39.3423 32.285 38.3022L36.7566 33.9488C37.0955 33.6199 37.2933 33.172 37.3078 32.6999C37.3224 32.2278 37.1528 31.7685 36.8348 31.4193L30.1156 24.031C29.7974 23.6806 29.3552 23.4681 28.8829 23.4386C28.4106 23.4091 27.9454 23.5648 27.5861 23.8727L23.6401 27.2569C23.3257 27.5724 23.138 27.9924 23.1127 28.4371C23.0854 28.8917 22.5654 39.6605 30.9157 48.0145C38.2004 55.2974 47.3254 55.8302 49.8385 55.8302C50.2058 55.8302 50.4313 55.8193 50.4913 55.8157C50.936 55.7908 51.3557 55.6023 51.6697 55.2865L55.052 51.3387C55.3602 50.9796 55.5162 50.5145 55.487 50.0422C55.4578 49.5699 55.2457 49.1276 54.8956 48.8092L47.5054 42.0882Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/callIcon.5f98e1f99bf00db94a3747f0626f6ec5.svg";
export { ForwardRef as ReactComponent };